import { useMutation, useQueryClient } from 'react-query';

import { IntegrationType } from 'src/generated/mloop-graphql';

import { putIntegration } from './integrationPut';
import { QUERY_KEY } from './types';
import { AshbyIntegrationQueryKey } from './useAshbyIntegration';

const INTEGRATION_TYPE: IntegrationType = IntegrationType.AshbyApiKey;

function putAshbyIntegration(apiKey: string, syncConfidentialJobs: boolean) {
  return putIntegration({
    integration_type: INTEGRATION_TYPE,
    ashby: {
      api_key: apiKey,
      sync_confidential_jobs: syncConfidentialJobs,
    },
  });
}

export default function useAshbyIntegrationPut() {
  const queryClient = useQueryClient();
  return useMutation(
    (data: { apiKey: string; syncConfidentialJobs: boolean }) =>
      putAshbyIntegration(data.apiKey, data.syncConfidentialJobs),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QUERY_KEY]);
        queryClient.invalidateQueries([QUERY_KEY, INTEGRATION_TYPE]);
        queryClient.invalidateQueries([AshbyIntegrationQueryKey]);
      },
    }
  );
}
